import { __assign, __awaiter, __generator, __rest } from "tslib";
import QueryBatcher from 'graphql-query-batcher';
import fetch from 'isomorphic-unfetch';
import { ClientError } from './error';
var DEFAULT_BATCH_OPTIONS = {
    maxBatchSize: 10,
    batchInterval: 40,
};
export var createFetcher = function (_a) {
    var url = _a.url, _b = _a.headers, headers = _b === void 0 ? {} : _b, fetcher = _a.fetcher, _c = _a.batch, batch = _c === void 0 ? false : _c, rest = __rest(_a, ["url", "headers", "fetcher", "batch"]);
    if (!url && !fetcher) {
        throw new Error('url or fetcher is required');
    }
    if (!fetcher) {
        fetcher = function (body) { return __awaiter(void 0, void 0, void 0, function () {
            var headersObject, _a, res, _b, _c, json;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!(typeof headers == 'function')) return [3 /*break*/, 2];
                        return [4 /*yield*/, headers()];
                    case 1:
                        _a = _d.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = headers;
                        _d.label = 3;
                    case 3:
                        headersObject = _a;
                        headersObject = headersObject || {};
                        return [4 /*yield*/, fetch(url, __assign({ headers: __assign({ 'Content-Type': 'application/json' }, headersObject), method: 'POST', body: JSON.stringify(body) }, rest))];
                    case 4:
                        res = _d.sent();
                        if (!!res.ok) return [3 /*break*/, 6];
                        _b = Error.bind;
                        _c = res.statusText + ": ";
                        return [4 /*yield*/, res.text()];
                    case 5: throw new (_b.apply(Error, [void 0, _c + (_d.sent())]))();
                    case 6: return [4 /*yield*/, res.json()];
                    case 7:
                        json = _d.sent();
                        return [2 /*return*/, json];
                }
            });
        }); };
    }
    if (!batch) {
        return function (body) { return __awaiter(void 0, void 0, void 0, function () {
            var json;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, fetcher(body)];
                    case 1:
                        json = _b.sent();
                        if ((_a = json === null || json === void 0 ? void 0 : json.errors) === null || _a === void 0 ? void 0 : _a.length) {
                            throw new ClientError(json.errors);
                        }
                        if (json === null || json === void 0 ? void 0 : json.data) {
                            return [2 /*return*/, json.data];
                        }
                        throw new Error('fetcher returned unexpected result ' + JSON.stringify(json));
                }
            });
        }); };
    }
    var batcher = new QueryBatcher(function (batchedQuery) { return __awaiter(void 0, void 0, void 0, function () {
        var json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetcher(batchedQuery)];
                case 1:
                    json = _a.sent();
                    return [2 /*return*/, json];
            }
        });
    }); }, batch === true ? DEFAULT_BATCH_OPTIONS : batch);
    return function (_a) {
        var query = _a.query, variables = _a.variables;
        return __awaiter(void 0, void 0, void 0, function () {
            var json;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, batcher.fetch(query, variables)];
                    case 1:
                        json = _c.sent();
                        if ((_b = json === null || json === void 0 ? void 0 : json.errors) === null || _b === void 0 ? void 0 : _b.length) {
                            throw new ClientError(json.errors);
                        }
                        if (json === null || json === void 0 ? void 0 : json.data) {
                            return [2 /*return*/, json.data];
                        }
                        throw new Error('fetcher returned unexpected result ' + JSON.stringify(json));
                }
            });
        });
    };
};
//# sourceMappingURL=fetcher.js.map